<template>
  <div class="animated fadeIn">
    <b-row>
      <PageTitle></PageTitle>
      <filter-area
        @filterData="filterData()"
        @resetData="resetFilerAreaData()"
      >
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label for="code">{{$t('filterArea.label.code')}}</label>
              <b-form-input
                type="text"
                id="code"
                :placeholder="$t('filterArea.label.code')"
                v-model="filterArea.code">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="label">{{$t('filterArea.label.name')}}</label>
              <b-form-input
                type="text"
                id="label"
                :placeholder="$t('filterArea.label.name')"
                v-model="filterArea.label">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </filter-area>

      <b-col lg="12">
        <b-card>
          <b-table
            :stacked="stacked"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="captions"
            :current-page="1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :per-page="perPage"
            @sort-changed="sortingChanged"
            :no-sort-reset="true"
            :no-local-sorting="true">
            <template slot="actions" slot-scope="data">
              <div class="btn-group" role="group">
                <router-link tag="button" class="btn btn-primary fa fa-search" v-b-tooltip.hover :title="$t('actions.show')"
                             :to="{name: 'procedureTypeShowRoute', params:{id: data.item.id}}">
                </router-link>
                <router-link v-if="isProcedureStandaloneMode" tag="button" class="btn btn-warning fa fa-edit" v-b-tooltip.hover :title="$t('actions.edit')"
                             :to="{name: 'procedureTypeEditRoute', params:{id: data.item.id}}">
                </router-link>
                <button v-if="isProcedureStandaloneMode" class="btn btn-danger" v-b-tooltip.hover :title="$t('actions.delete')" @click="handleDelete(data.item)">
                  <i class="far fa-trash" />
                </button>
              </div>
            </template>
          </b-table>

          <div class="row">
            <div class="col-sm-4">
              <b-pagination :total-rows="rowCount" :per-page="perPage" v-model="currentPage"
                            :prev-text="$t('actions.previous')"
                            :next-text="$t('actions.next')"
                            hide-goto-end-buttons @input="fetchData(currentPage)"/>
            </div>
            <div class="col-sm-6"></div>
            <div class="col-sm-2">
              <router-link v-if="isProcedureStandaloneMode" class="btn btn-primary btn-block float-right" role="button" :to="{path: `/procedureTypes/new`}" push>
                {{ $t('actions.create') }}
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Eliminazione Tipologia Prestazione" class="modal-danger" v-model="deleteModal" @ok="deleteProcedureType"
             ok-variant="danger" v-if="selectedProcedureType">
      {{ $t('page.generic.deleteMessage', {n: selectedProcedureType.code}) }}
    </b-modal>
  </div>
</template>
<script>
import PageTitle from '@/components/PageTitle'
import i18n from '@/config/i18n'
import FilterArea from '../../components/FilterArea'
import miniToastr from 'mini-toastr'
import ProcedureTypeService from "@/services/ProcedureTypeService";
import Costants from "@/constants"; //ES6

const procedureTypeService = ProcedureTypeService.build()

export default {
  name: 'ProcedureTypeList',
  inheritAttrs: false,
  components: {
    PageTitle,
    FilterArea,
  },
  props: {
    caption: {
      type: String,
      default: 'Tipologie Prestazioni'
    },
    stacked: {
      type: String,
      default: 'sm'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 7
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'code',
          sortable: true,
          label: i18n.t('page.generic.code')
        },
        {
          key: 'label',
          sortable: true,
          label: i18n.t('page.generic.name'),
        },
        {
          key: 'description',
          sortable: false,
          label: i18n.tc('page.generic.description')
        },
        {
          key: 'actions',
          sortable: false,
          label: 'Azioni'
        }
      ],
      currentPage: 1,
      tableData: [],
      tableTotalRows: 0,
      sortBy: 'code',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterArea: {},
      deleteModal: false,
      selectedProcedureType: null
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.fetchData(1);
  },
  computed: {
    items: function () {
      const items = this.tableData;
      return Array.isArray(items) ? items : []
    },
    captions: function () {
      return this.fields
    },
    rowCount: function () {
      return this.tableTotalRows
    },
    isProcedureStandaloneMode: function() {
      return JSON.parse(localStorage.getItem('configurations')).procedureMode === Costants.PROCEDURE_STANDALONE_MODE
    }
  },
  methods: {
    async fetchData(currentPage) {
      (
        {
          data: this.tableData = [],
          total: this.tableTotalRows = 0
        } = await procedureTypeService.search(
          {
            max: this.perPage,
            offset: (currentPage - 1) * this.perPage,
            sort: this.sortBy,
            order: (this.sortDesc ? 'desc' : 'asc'),
            enabled: this.filterArea.state,
            code: this.filterArea.code,
            label: this.filterArea.label,
          }
        )
      )

    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.fetchData(this.currentPage)
    },
    filterData(){
      this.fetchData(1)
    },
    resetFilerAreaData(){
      this.filterArea = {
        state : null,
        code: null,
        label: null,
      };
      this.fetchData(1)
    },
    handleDelete(procedureType) {
      this.deleteModal = true;
      this.selectedProcedureType = procedureType;
    },
    async deleteProcedureType() {
      try {
        // TODO Verificare cancellazione solo se non associata ad altre prestazioni
        await procedureTypeService.destroy(this.selectedProcedureType.id);
        this.$router.replace({name: 'procedureTypeRoute'});
        miniToastr.info("Tipologia Procedura cancellata con successo!")
      } catch (exception) {
        miniToastr.error(exception.message)
      } finally {
        this.procedureType = null;
        this.fetchData(this.currentPage)
      }
    }
  }
}
</script>

